export const SET_LOCALE_LANG = 'SET_LOCALE_LANG'

export interface LocaleState {
    lang: string
}

interface SetLocaleLangAction {
    type: typeof SET_LOCALE_LANG
    locale: string
}

type LocaleAction = SetLocaleLangAction

/**
 * Set locale language
 */
function setLocaleLang(state: LocaleState, lang: string): LocaleState {
    return {
        ...state,
        lang: lang,
    }
}

/**
 * Reducer for locale
 */
export default function reducer(state: LocaleState = [] as unknown as LocaleState, action: LocaleAction): LocaleState {
    switch (action.type) {
        case SET_LOCALE_LANG: return setLocaleLang(state, action.locale)
        default: return state
    }
}
